import { Metadata } from '@gojob/cms';
import { graphql, useStaticQuery } from 'gatsby';

export type SiteMetadataQueryResponse = {
  sanitySiteMetadata?: {
    metadata?: Metadata;
  };
};

const SiteMetadataQuery = graphql`
  query SiteMetadataQuery {
    sanitySiteMetadata {
      metadata {
        ...MetadataFragment
      }
    }
  }
`;

const useDefaultMetadata = () => {
  const { sanitySiteMetadata } = useStaticQuery<SiteMetadataQueryResponse>(SiteMetadataQuery);

  return sanitySiteMetadata?.metadata || {};
};

export default useDefaultMetadata;
